import {
  MailSignupFailModal,
  MailSignupSuccessModal,
  handleEmailSubmit,
  validateMailAddress,
} from "./utils"
import React, { useEffect, useState } from "react"

import { EnvelopeClosedIcon } from "components/page-components/Icons/small"

import { getInterestData } from "data/newsletter-interest-abbreviations"

export const NewsletterSignupBarebones = ({
  ressort = "ausschreibungsdienste",
  is_inverted,
}) => {
  const assumed_interest = getInterestData({ ressort })

  const [mail_address, set_mail_address] = useState("")
  const update_mail_address = (e) => set_mail_address(e.target.value)
  const [interests_array] = useState([assumed_interest.abbreviation]) //needs to be an array!
  const [valid_email, set_valid_email] = useState(false)
  const [success_modal_class, set_success_modal_class] = useState("")
  const [fail_modal_class, set_fail_modal_class] = useState("")
  const [checkbox_datenschutz, set_checkbox_datenschutz] = useState(false)
  const toggle_datenschutz = (e) => {
    e.target.tagName !== "A" && e.preventDefault()
    set_checkbox_datenschutz(!checkbox_datenschutz)
  }
  const [button_loading, set_button_loading] = useState(false)

  const handle_submit = async () => {
    set_button_loading(true)
    handleEmailSubmit({
      list: "newsletter",
      email: mail_address,
      interests: interests_array,
      launchModal,
    })
  }

  const handle_enter = (e) => {
    if (e.key === "Enter" && valid_email && checkbox_datenschutz) {
      handle_submit()
      return
    }
  }

  const launchModal = (success) => {
    success
      ? set_success_modal_class("is-active")
      : set_fail_modal_class("is-active")
  }

  useEffect(() => {
    set_valid_email(validateMailAddress(mail_address))
  }, [mail_address])

  return (
    <React.Fragment>
      <div
        data-nosnippet
        className="columns is-centered is-vcentered is-gapless"
      >
        <div className="column is-9">
          <div className="control has-icons-left">
            <input
              className="input"
              type="text"
              placeholder="E-Mail"
              onChange={update_mail_address}
              onKeyDown={handle_enter}
              aria-label="email-newsletter"
            />
            <span className="icon is-medium is-left">
              <EnvelopeClosedIcon {...{ color: "#b3cbd4" }} />
            </span>
          </div>
        </div>
        <div className="column is-3 has-text-centered">
          <button
            className={`button is-sonnengelb is-fullwidth ${
              button_loading ? "is-loading" : ""
            }`}
            disabled={
              !valid_email ||
              !checkbox_datenschutz ||
              interests_array.length < 1
            }
            onClick={handle_submit}
          >
            <b>Anmelden</b>
          </button>
        </div>
      </div>

      <div
        data-nosnippet
        className="signup-checkboxes "
        style={{
          transition: `.2s ease`,
          maxHeight: valid_email ? "200px" : "0px",
          opacity: valid_email ? "1" : "0",
          visibility: valid_email ? "visible" : "hidden",
        }}
      >
        <div className="is-flex checkbox-item">
          <div
            onClick={toggle_datenschutz}
            aria-label="Datenschutzbestimmungen akzeptieren"
            role="button"
            tabIndex="-1"
            onKeyDown={toggle_datenschutz}
            className={`checkbox${checkbox_datenschutz ? " is-refined" : ""}`}
          ></div>
          <span
            onClick={toggle_datenschutz}
            aria-label="Datenschutzbestimmungen akzeptieren"
            role="button"
            tabIndex="-2"
            onKeyDown={toggle_datenschutz}
            className={`my-auto is-clickable has-text-left help${is_inverted ? " has-text-white" : ""}`}
          >
            Ich akzeptiere die{" "}
            <a
              href="/datenschutzerklaerung"
              target="_blank"
              rel="noopener noreferrer"
              className={`link${is_inverted ? " has-text-white" : ""}`}
            >
              Datenschutz-Bestimmungen
            </a>
            .
          </span>
        </div>
      </div>

      <div className="mb 2"></div>

      <MailSignupSuccessModal
        {...{
          successModalClass: success_modal_class,
          setButtonLoading: set_button_loading,
          setSuccessModalClass: set_success_modal_class,
        }}
      />

      <MailSignupFailModal
        {...{
          failModalClass: fail_modal_class,
          setButtonLoading: set_button_loading,
          setFailModalClass: set_fail_modal_class,
        }}
      />
    </React.Fragment>
  )
}
